import { Tooltip } from "@atd/components";
import Icon from "@atd/components/Icon/Icon";

function HelpButton() {
  return (
    <Tooltip content="Help">
      <span className="TopNavIcon">
        <Icon
          icon="help"
          onClick={() =>
            window.open("mailto:hello@alltimedesign.com", "_blank")
          }
        />
      </span>
    </Tooltip>
  );
}

export default HelpButton;
